// Modulo do atendimento WhatsApp (Fase 3). Namespaced, ao contrario do
// estado de auth/user que vive solto na raiz (ver auditoria da Fase 3) -
// aqui comecamos do jeito certo por nao ter nada legado que dependa disso.
import { inscreverPrivado, sairDoCanal } from '@/plugins/echo'
import env from '@/config/env'

// Mesma convencao do resto do app (ver store/index.js `state.api`): nenhum
// axios instance tem baseURL configurada, toda URL e montada na mao.
function baseUrl() {
  return env.baseURL
}

export default {
  namespaced: true,

  state: {
    conversas: [],
    carregandoConversas: false,
    conversaAtivaId: null,
    conversaAtiva: null,
    mensagensPorConversa: {},
    carregandoMensagens: false,
    filtroAba: 'todos',
    filtroDepartamentoId: null,
    // Muda de referencia a cada mensagem nova (mesmo repetida) pra um watch
    // sempre disparar - ver Painel.vue, que decide se toca som/mostra toast.
    ultimaNotificacao: null,
  },

  getters: {
    mensagensDaConversaAtiva(state) {
      if (!state.conversaAtivaId) return []
      return state.mensagensPorConversa[state.conversaAtivaId] || []
    },
  },

  mutations: {
    SET_CARREGANDO_CONVERSAS(state, valor) {
      state.carregandoConversas = valor
    },
    SET_CONVERSAS(state, conversas) {
      state.conversas = conversas
    },
    UPSERT_CONVERSA(state, conversa) {
      const indice = state.conversas.findIndex(c => c.id === conversa.id)
      if (indice === -1) {
        state.conversas.unshift(conversa)
      } else {
        state.conversas.splice(indice, 1, conversa)
      }
    },
    REMOVER_CONVERSA(state, id) {
      state.conversas = state.conversas.filter(c => c.id !== id)
    },
    ZERAR_NAO_LIDAS(state, atendimentoId) {
      const indice = state.conversas.findIndex(c => c.id === atendimentoId)
      if (indice !== -1) {
        state.conversas.splice(indice, 1, { ...state.conversas[indice], nao_lidas: 0 })
      }
      if (state.conversaAtiva && state.conversaAtiva.id === atendimentoId) {
        state.conversaAtiva = { ...state.conversaAtiva, nao_lidas: 0 }
      }
    },
    SET_CONVERSA_ATIVA(state, { id, conversa }) {
      state.conversaAtivaId = id
      state.conversaAtiva = conversa || null
    },
    // assumir/transferir/encerrar/reabrir devolvem o atendimento "cru" (sem
    // contato/departamento/user carregados, diferente do GET usado em
    // selecionarConversa) - MESCLA por cima do que já está na tela em vez
    // de substituir, senão contato/departamento somem (vira "Desconhecido")
    // até o próximo F5. Só aplica se ainda for a mesma conversa aberta.
    ATUALIZAR_CONVERSA_ATIVA_SE_FOR(state, atendimento) {
      if (state.conversaAtivaId === atendimento.id) {
        state.conversaAtiva = { ...state.conversaAtiva, ...atendimento }
      }
    },
    SET_CARREGANDO_MENSAGENS(state, valor) {
      state.carregandoMensagens = valor
    },
    SET_MENSAGENS(state, { atendimentoId, mensagens }) {
      state.mensagensPorConversa = { ...state.mensagensPorConversa, [atendimentoId]: mensagens }
    },
    ADICIONAR_MENSAGEM(state, { atendimentoId, mensagem }) {
      const atuais = state.mensagensPorConversa[atendimentoId] || []
      if (atuais.some(m => m.id === mensagem.id)) return
      state.mensagensPorConversa = {
        ...state.mensagensPorConversa,
        [atendimentoId]: [...atuais, mensagem],
      }
    },
    ATUALIZAR_STATUS_MENSAGEM(state, { atendimentoId, mensagemId, status }) {
      const atuais = state.mensagensPorConversa[atendimentoId] || []
      const indice = atuais.findIndex(m => m.id === mensagemId)
      if (indice === -1) return
      const copia = [...atuais]
      copia[indice] = { ...copia[indice], status }
      state.mensagensPorConversa = { ...state.mensagensPorConversa, [atendimentoId]: copia }
    },
    ATUALIZAR_MIDIA_MENSAGEM(state, { atendimentoId, mensagemId, midia }) {
      const atuais = state.mensagensPorConversa[atendimentoId] || []
      const indice = atuais.findIndex(m => m.id === mensagemId)
      if (indice === -1) return
      const copia = [...atuais]
      copia[indice] = { ...copia[indice], midia }
      state.mensagensPorConversa = { ...state.mensagensPorConversa, [atendimentoId]: copia }
    },
    SET_ULTIMA_NOTIFICACAO(state, dados) {
      state.ultimaNotificacao = dados
    },
    SET_FILTRO_ABA(state, aba) {
      state.filtroAba = aba
    },
    SET_FILTRO_DEPARTAMENTO(state, departamentoId) {
      state.filtroDepartamentoId = departamentoId
    },
  },

  actions: {
    async carregarConversas({ commit, state }) {
      commit('SET_CARREGANDO_CONVERSAS', true)
      const params = { limit: 50 }

      if (state.filtroAba === 'fila') {
        params.estado = 'fila'
      } else if (state.filtroAba === 'minhas') {
        params.estado = 'em_atendimento'
        params.minhas = true
      } else if (state.filtroAba === 'encerrados') {
        params.estado = 'encerrado'
      }
      // 'todos' nao filtra por estado

      if (state.filtroDepartamentoId) {
        params.departamento_id = state.filtroDepartamentoId
      }

      try {
        const resposta = await window.axios.get(baseUrl() + 'atendimentos', { params })
        commit('SET_CONVERSAS', resposta.data.data)
      } finally {
        commit('SET_CARREGANDO_CONVERSAS', false)
      }
    },

    async selecionarConversa({ commit, dispatch }, atendimentoId) {
      const resposta = await window.axios.get(baseUrl() + 'atendimentos/' + atendimentoId)
      commit('SET_CONVERSA_ATIVA', { id: atendimentoId, conversa: resposta.data })
      await dispatch('carregarMensagens', atendimentoId)
      dispatch('inscreverCanalConversa', atendimentoId)

      // Otimista: zera na hora, sem esperar o back confirmar - abrir a
      // conversa e ela ja "ter sido vista" e a mesma coisa aqui.
      commit('ZERAR_NAO_LIDAS', atendimentoId)
      window.axios.post(baseUrl() + 'atendimentos/' + atendimentoId + '/marcar-lido').catch(() => {})
    },

    async carregarMensagens({ commit }, atendimentoId) {
      commit('SET_CARREGANDO_MENSAGENS', true)
      try {
        const resposta = await window.axios.get(baseUrl() + 'atendimentos/' + atendimentoId + '/mensagens')
        commit('SET_MENSAGENS', { atendimentoId, mensagens: resposta.data.data })
      } finally {
        commit('SET_CARREGANDO_MENSAGENS', false)
      }
    },

    inscreverCanalConversa({ commit }, atendimentoId) {
      const canal = inscreverPrivado('atendimento.' + atendimentoId)
      canal
        .listen('.mensagem.recebida', evento => {
          commit('ADICIONAR_MENSAGEM', { atendimentoId, mensagem: evento.mensagem })
        })
        .listen('.mensagem.enviada', evento => {
          commit('ADICIONAR_MENSAGEM', { atendimentoId, mensagem: evento.mensagem })
        })
        .listen('.mensagem.status-atualizada', evento => {
          commit('ATUALIZAR_STATUS_MENSAGEM', {
            atendimentoId,
            mensagemId: evento.mensagem_id,
            status: evento.status,
          })
        })
        .listen('.mensagem.midia-pronta', evento => {
          commit('ATUALIZAR_MIDIA_MENSAGEM', {
            atendimentoId,
            mensagemId: evento.mensagem.id,
            midia: evento.mensagem.midia,
          })
        })
    },

    sairCanalConversa(_ctx, atendimentoId) {
      sairDoCanal('atendimento.' + atendimentoId)
    },

    // Fila de um departamento: nao tenta reconciliar o payload parcial do
    // evento (o broadcast so serializa o atendimento puro, sem contato/
    // departamento/ultima_mensagem carregados) - so recarrega a lista.
    // Mais simples e sempre correto; o custo de mais uma chamada por
    // evento e desprezivel nessa escala.
    inscreverCanaisDepartamento({ dispatch }, departamentoIds) {
      const eventos = [
        '.atendimento.entrou-na-fila',
        '.atendimento.assumido',
        '.atendimento.transferido',
        '.atendimento.encerrado',
        '.atendimento.reaberto',
      ]

      departamentoIds.forEach(id => {
        const canal = inscreverPrivado('departamento.' + id)
        eventos.forEach(nomeEvento => {
          canal.listen(nomeEvento, () => dispatch('carregarConversas'))
        })
      })
    },

    sairCanaisDepartamento(_ctx, departamentoIds) {
      departamentoIds.forEach(id => sairDoCanal('departamento.' + id))
    },

    // Canal usuario.{id} + os mesmos departamento.{id} de cima, so que
    // escutando mensagem.recebida - e o que permite avisar (som/toast) de
    // uma mensagem nova numa conversa que nem esta aberta na tela, E
    // manter a lista (previa/nao-lidas/ordem) atualizada sem F5. So guarda
    // o dado bruto da notificacao no state; quem decide tocar som/mostrar
    // toast e o componente (Painel.vue), que tem o $message/document.hidden.
    //
    // A MESMA mensagem chega em MAIS de um canal quando o atendimento tem
    // dono E departamento (usuario.X e departamento.Y ao mesmo tempo) -
    // sem esse dedup por wamid/id, o toast dispara em dobro.
    inscreverNotificacoesGlobais({ commit, dispatch }, { usuarioId, departamentoIds }) {
      const canais = []
      if (usuarioId) canais.push('usuario.' + usuarioId)
      departamentoIds.forEach(id => canais.push('departamento.' + id))

      const idsJaProcessados = new Set()

      canais.forEach(nomeCanal => {
        inscreverPrivado(nomeCanal).listen('.mensagem.recebida', evento => {
          if (idsJaProcessados.has(evento.mensagem.id)) return
          idsJaProcessados.add(evento.mensagem.id)

          commit('SET_ULTIMA_NOTIFICACAO', {
            atendimentoId: evento.atendimento_id,
            contatoNome: evento.contato_nome,
            texto: evento.mensagem.texto,
            tipo: evento.mensagem.tipo,
            chave: Date.now() + '-' + evento.mensagem.id,
          })
          dispatch('carregarConversas')
        })
      })
    },

    sairNotificacoesGlobais(_ctx, { usuarioId, departamentoIds }) {
      if (usuarioId) sairDoCanal('usuario.' + usuarioId)
      departamentoIds.forEach(id => sairDoCanal('departamento.' + id))
    },

    async enviarTexto({ commit }, { atendimentoId, texto, clientId }) {
      const resposta = await window.axios.post(baseUrl() + 'atendimentos/' + atendimentoId + '/mensagens', {
        texto,
        client_id: clientId,
      })
      commit('ADICIONAR_MENSAGEM', { atendimentoId, mensagem: resposta.data })
      return resposta.data
    },

    async assumir({ commit, dispatch }, atendimentoId) {
      const resposta = await window.axios.post(baseUrl() + 'atendimentos/' + atendimentoId + '/assumir')
      commit('ATUALIZAR_CONVERSA_ATIVA_SE_FOR', resposta.data)
      await dispatch('carregarConversas')
      return resposta.data
    },

    async transferir({ commit, dispatch }, { atendimentoId, departamentoId }) {
      const resposta = await window.axios.post(baseUrl() + 'atendimentos/' + atendimentoId + '/transferir', {
        departamento_id: departamentoId,
      })
      commit('ATUALIZAR_CONVERSA_ATIVA_SE_FOR', resposta.data)
      await dispatch('carregarConversas')
      return resposta.data
    },

    async atribuir({ commit, dispatch }, { atendimentoId, userId }) {
      const resposta = await window.axios.post(baseUrl() + 'atendimentos/' + atendimentoId + '/atribuir', {
        user_id: userId,
      })
      commit('ATUALIZAR_CONVERSA_ATIVA_SE_FOR', resposta.data)
      await dispatch('carregarConversas')
      return resposta.data
    },

    async encerrar({ commit, dispatch }, atendimentoId) {
      const resposta = await window.axios.post(baseUrl() + 'atendimentos/' + atendimentoId + '/encerrar')
      commit('ATUALIZAR_CONVERSA_ATIVA_SE_FOR', resposta.data)
      await dispatch('carregarConversas')
      return resposta.data
    },

    async reabrir({ commit, dispatch }, atendimentoId) {
      const resposta = await window.axios.post(baseUrl() + 'atendimentos/' + atendimentoId + '/reabrir')
      commit('ATUALIZAR_CONVERSA_ATIVA_SE_FOR', resposta.data)
      await dispatch('carregarConversas')
      return resposta.data
    },

    async enviarMidia({ commit }, { atendimentoId, arquivo, legenda }) {
      const dadosFormulario = new FormData()
      dadosFormulario.append('arquivo', arquivo)
      if (legenda) dadosFormulario.append('legenda', legenda)

      const resposta = await window.axios.post(
        baseUrl() + 'atendimentos/' + atendimentoId + '/midias',
        dadosFormulario
      )
      commit('ADICIONAR_MENSAGEM', { atendimentoId, mensagem: resposta.data })
      return resposta.data
    },

    async adicionarNota({ commit }, { atendimentoId, descricao }) {
      const resposta = await window.axios.post(baseUrl() + 'atendimentos/' + atendimentoId + '/notas', { descricao })
      return resposta.data
    },
  },
}
